import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// GET
// /Api/Vendor/Vendors
export async function getVendorsData() {
  const response = await axios.get('Vendor/Vendors');
  return response;
}

// GET
// /Api/Vendor/IntegratedVendors
export async function getIntegratedVendorsData() {
  const response = await axios.get('Vendor/IntegratedVendors');
  return response;
}

// GET
// /Api/Vendor/VendorDetail vendorId
export async function getVendorDetailData(vendorId) {
  const response = await axios.get(`Vendor/VendorDetail?vendorId=${vendorId}`);
  return response;
}

// POST
// /Api/Vendor/VendorForm
export async function postVendorForm(form) {
  const files = form.files; 

  const updatedForm = {
    Name: form.name,
    EmailTo: form.emailTo,
    EmailToCC: form.emailToCC,
    Address: form.address,
    Zip: form.zip,
    City: form.city,
    State: form.state,
    Phone: form.phone,
    Logo: form.logo,
    RemitCompanyName: form.remitCompany,
    RemitAddress: form.remitAddress,
    RemitCity: form.remitCity,
    RemitState: form.remitState,
    RemitZip: form.remitZip,
    FileTypeId: form.fileTypeId, //W9 Files
  };

  const formData = objectToFormData({
    ...updatedForm,
    files,
  });

  const response = await axios.post('Vendor/VendorForm', formData);
  return response;
}
// POST
// /Api/Vendor/VendorForm
export async function postEditVendorForm(form, id) {
  const updatedForm = {
    Name: form.name,
    Id: id,
    EmailTo: form.emailTo,
    EmailToCC: form.emailToCC,
    OrderAddressEditable: form.editableOrderAddress,
    Address: form.address,
    Zip: form.zip,
    City: form.city,
    State: form.state,
    Phone: form.phone,
    Logo: form.logo,
    RemitCompanyName: form.remitCompany,
    RemitAddress: form.remitAddress,
    RemitCity: form.remitCity,
    RemitState: form.remitState,
    RemitZip: form.remitZip,
  };

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Vendor/VendorForm', formData);
  return response;
}

export async function postEditVendorContactForm(form, vendorId, contactId) {
  const updatedForm = {
    LastName: form.lastName,
    FirstName: form.firstName,
    Email: form.email,
    Phone: form.phone,
    PositionId: form.position === null ? 0 : form.position.value,
  };
  const formData = objectToFormData({
    ...updatedForm,
    vendorId,
    contactId,
  });

  const response = await axios.post(`Vendor/VendorContactForm`, formData);
  return response;
}

export async function postDeleteVendorContact(vendorId, contactId) {
  const formData = objectToFormData({
    vendorId,
    contactId,
  });
  const response = await axios.post(`Vendor/DeleteVendorContact`, formData);
  return response;
}
// GET
// /Api/Vendor/DownloadVendors
////Download Api is used in code bec we need the `${HOST_API_URL}

// POST
// /Api/Vendor/DeleteVendor id
export async function postDeleteVendor(id) {
  const response = await axios.post(`Vendor/DeleteVendor?id=${id}`);
  return response;
}

// GET
// /Api/Vendor/VendorFiles vendorId
export async function getVendorFilesData(vendorId) {
  const response = await axios.get(`Vendor/VendorFiles?vendorId=${vendorId}`);
  return response;
}

// POST
// /Api/Vendor/AddVendorFiles vendorId  fileTypeId files
export async function postAddVendorFiles(vendorId, fileTypeId, files) {
  const formData = objectToFormData({
    vendorId,
    fileTypeId,
    files,
  });
  const response = await axios.post('Vendor/AddVendorFiles', formData);
  return response;
}

// GET
// /Api/Vendor/DownloadVendorFile
////Download Api is used in code bec we need the `${HOST_API_URL}

// POST
// /Api/Vendor/DeleteVendorFile id
export async function postDeleteVendorFile(id) {
  const response = await axios.post(`Vendor/DeleteVendorFile?id=${id}`);
  return response;
}

// GET
// /Api/Vendor/VendorMinimums
export async function getVendorMinimumsData() {
  const response = await axios.get('Vendor/VendorMinimums');
  return response;
}

// POST
// /Api/Vendor/VendorMinimumForm
export async function postVendorMinimumForm(form, id) {
  const updatedForm = {
    FacilityId: form.facility.id,
    VendorId: form.vendor.id,
    MinimumTotal: form.minimumTotal,
    Note: form.note,
  };
  if (id) {
    updatedForm.id = id;
  }

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Vendor/VendorMinimumForm', formData);
  return response;
}

// POST
// /Api/Vendor/DeleteVendorMinimum
export async function postDeleteVendorMinimum(id) {
  const response = await axios.post(`Vendor/DeleteVendorMinimum?id=${id}`);
  return response;
}

// GET
// /Api/Vendor/VendorDates facilityId vendorId
export async function getVendorDatesData(facilityId, vendorId) {
  const response = await axios.post(`Vendor/VendorDates`, objectToFormData({ facilityId, vendorId }));
  return response;
}

// POST
// /Api/Vendor/VendorDateForm FacilityId VendorId form

function convertToUTC(dateString) {
  const date = new Date(dateString);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
}

export async function postVendorDateForm(form, selectedEventId) { 
  const response = await axios.post('Vendor/VendorDateForm', objectToFormData({
    cutoffStartDate: form.cutoffStart ? convertToUTC(form.cutoffStart) : null,
    cutoffEndDate: form.cutoffEnd ? convertToUTC(form.cutoffEnd) : null,
    shipDate: form.shipDate ? convertToUTC(form.shipDate) : null,
    weekly: form.weekly,
    biweekly: form.biweekly,
    id: selectedEventId,
    facilityId: form.facilityId,
    vendorId: form.vendorId
  }));
  return response;
}

// POST
// /Api/Vendor/DeleteVendorDate id
export async function postDeleteVendorDate(id) {
  const response = await axios.post(`Vendor/DeleteVendorDate?id=${id}`);
  return response;
}

// // GET
// // /Api/Vendor/DownloadVendorDates
////Download Api is used in code bec we need the `${HOST_API_URL}

// // GET
// // /Api/Vendor/DownloadVendorItems
////Download Api is used in code bec we need the `${HOST_API_URL}

// GET
// /Api/Vendor/VendorIntegrationsNotes
export async function getVendorIntegrationsNotesData() {
  const response = await axios.get('Vendor/VendorIntegrationsNotes');
  return response;
}

// GET
// /Api/Vendor/VendorEDIIntegrations
// export async function getVendorEDIIntegrationsData() {
//   const response = await axios.get('Vendor/VendorEDIIntegrations');
//   return response;
// }

// POST
// /Api/Vendor/VendorIntegrationNoteForm
export async function postVendorIntegrationNoteForm(form, id) {
  const updatedProgressUpdates = form.progressUpdates.map((progressUpdate) => {
    const updatedProgressUpdate = {
      message: progressUpdate.message,
    };
    return updatedProgressUpdate;
  });

  const updatedForm = {
    TypeId: form?.type.id,
    VendorId: form.vendor.id,
    Description: form.description,
    PrimaryContact: form.primaryContact,
    Complete: form.complete || false,
    ProgressUpdates: id && form.progressUpdates.length > 0 ? updatedProgressUpdates : form.progressUpdates || [],
  };
  if (id) {
    updatedForm.id = id;
  }

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Vendor/VendorIntegrationNoteForm', formData);
  return response;
}

// POST
// /Api/Vendor/DeleteVendorIntegrationNote id
export async function postDeleteVendorIntegrationNote(id) {
  const response = await axios.post(`Vendor/DeleteVendorIntegrationNote?id=${id}`);
  return response;
}

// GET
// /Api/Vendor/EmailPickups
export async function getEmailPickupsData() {
  const response = await axios.get('Vendor/EmailPickups');
  return response;
}

// GET
// /Api/Vendor/EmailPickupsIgnored
export async function getEmailPickupsIgnoredData() {
  const response = await axios.get('Vendor/EmailPickupsIgnored');
  return response;
}

// POST
// /Api/Vendor/EmailPickupForm id form
export async function postEmailPickupForm(form, id) {
  const updatedForm = {
    VendorId: form.vendor.id,
    Value: form.value,
    Type: form?.type.label,
    For: form.for.label,
  };
  if (id) {
    updatedForm.id = id;
  }

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Vendor/EmailPickupForm', formData);
  return response;
}

// POST
// /Api/Vendor/EmailIgnoreForm
export async function postEmailIgnoreForm(form, id) {
  const updatedForm = {
    VendorId: form.vendor.id,
    AreaId: form.area.id,
    Value: form.value,
    AllSites: form.allSites || false,
  };
  if (id) {
    updatedForm.id = id;
  }

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Vendor/EmailIgnoreForm', formData);
  return response;
}

// POST
// /Api/Vendor/DeleteEmailIgnore
export async function postDeleteEmailIgnore(id) {
  const response = await axios.post(`Vendor/DeleteEmailIgnore?id=${id}`);
  return response;
}

// POST
// /Api/Vendor/DeleteEmailPickup
export async function postDeleteEmailPickup(id) {
  const response = await axios.post(`Vendor/DeleteEmailPickup?id=${id}`);
  return response;
}

// POST
// /Api/Vendor/TriggerEmailPickup id
export async function postTriggerEmailPickup(id) {
  const response = await axios.post(`Vendor/TriggerEmailPickup?id=${id}`);
  return response;
}

// GET
// /Api/Vendor/VendorRules
export async function getVendorRulesData() {
  const response = await axios.get('Vendor/VendorRules');
  return response;
}


export async function getVendorItemsData() {
  const response = await axios.get(`ViewAllSKUs`);
  return response;
}
// POST
// /Api/Vendor/DeleteVendorRule id
export async function postDeleteVendorRule(id) {
  const response = await axios.post(`Vendor/DeleteVendorRule?id=${id}`);
  return response;
}

// POST
// /Api/Vendor/VendorRuleForm id form
export async function postVendorRuleForm(form, id) {
  const updatedForm = {
    VendorId: form.vendor.id,
    RuleTypeId: form?.type.id,
    RuleId: form.rule.id,
    Values: form.values,
  };
  if (id) {
    updatedForm.id = id;
  }

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Vendor/VendorRuleForm', formData);
  return response;
}

// GET
// /Api/Vendor/IntegrationDefinitionsData integrationType
export async function getIntegrationDefinitionsData(integrationType) {
  const response = await axios.get(`Vendor/IntegrationDefinitionsData?integrationType=${integrationType}`);
  return response;
}

// POST
// /Api/Vendor/IntegrationForm  vendorId integrationType OrderingDisabled id definitions
export async function postIntegrationForm({ vendorId, integrationType, orderingDisabled, definitions }) {
  const formData = objectToFormData({
    vendorId,
    type: integrationType,
    orderingDisabled,
    definitions: definitions.filter((def) => def.vendorId === vendorId),
  });
  const response = await axios.post('Vendor/IntegrationForm', formData);
  return response;
}

// POST
// /Api/Vendor/DeleteIntegration integrationType id
export async function postDeleteIntegration(vendorId, integrationType) {
  const response = await axios.post(`Vendor/DeleteIntegration?vendorId=${vendorId}&integrationType=${integrationType}`);
  return response;
}

// GET
// /Api/Vendor/AccountExtraFields vendorId accountId
export async function getAccountExtraFieldsData(vendorId, accountId) {
  const response = await axios.get(`FacilityAccount/AccountExtraFields?vendorId=${vendorId}&accountId=${accountId}`);
  return response;
}
export async function getVendorContacts(vendorId) {
  const response = await axios.get(`Vendor/VendorContacts?vendorId=${vendorId}`);
  return response;
}
export async function addContact(vendorId) {
  const response = await axios.get(`Vendor/VendorContacts?vendorId=${vendorId}`);
  return response;
}
export async function getVendorContactPositions() {
  const response = await axios.get(`Vendor/VendorContactPositions`);
  return response;
}
export async function getVendorOrders(vendorId, startDate, endDate) {
  const response = await axios.get(`Vendor/VendorOrders?vendorId=${vendorId}&start=${startDate}&end=${endDate}`);
  return response;
}

export async function getPriceAccounts() {
  const response = await axios.get(`Vendor/VendorPriceAccounts`);
  return response;
}

export async function getVendorPriceAccounts(vendorId) {
  const response = await axios.get(`Vendor/VendorPriceAccountsByVendor?vendorId=${vendorId}`);
  return response;
}

export async function vendorPriceAccountForm({ id, vendorId, accountNumber, description }) {
  const response = await axios.post('Vendor/VendorPriceAccountForm', objectToFormData({ id, vendorId, accountNumber, description }));
  return response;
}

export async function deleteVendorPriceAccount(id) {
  const response = await axios.post(`Vendor/DeleteVendorPriceAccount?id=${id}`);
  return response;
}
